import React from 'react';

import { translate as t } from '../../lib/I18n';
import Assets from '../../helpers/Assets';
import config from '../../config';

import Icon from '../general/Icon';

function NREHeader () {
    return (
        <div className="transfer-images margin-bottom margin-top">
            <img src={ Assets.assetUrl("images/national-rail-logo.png") } alt={ t('nre.logoAltText') } />
            <Icon icon="arrowback" className="otrl-rotate-180 text-secondary" />
            <img src={ `/images/logos/${ config.get('brand')}-logo.png` } alt="brand logo" />
        </div>
    );
}

export default NREHeader;
